import Logo from "../../Assets/Images/Weddingly_New_Logo.svg";
import { Box, Container, Grid, useScrollTrigger } from "@mui/material";
import StickyNavbar from "../StickyNavbar";
import Menu from "../../Routes/Home/Components/Menu";
import { styled } from "@mui/material/styles";
import SideBar from "../../Routes/Home/Components/SideBar/SideBar";

const HeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'scrolled',
})(({ theme, scrolled }) => ({
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 3,
  height: "116px",
  display: "flex",
  alignItems: "center",
  backgroundColor: scrolled
    ? `${theme.palette.custom.lightPink}E6`
    : "transparent",
  backdropFilter: scrolled ? "blur(10px)" : "none",
  boxShadow: scrolled ? "4px 4px 4px 0px #00000040" : "none",
  transition:
    "background-color 0.3s ease, backdrop-filter 0.3s ease, box-shadow 0.3s ease",
}));

const LogoContainer = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "flex-start",
  gap: "16px",
  alignItems: "center",
}));

const NavContainer = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "flex-start",
}));

const Header = ({ menuIsOpen, setMenuIsOpen, currentPath, onTabChange }) => {
  const scrolled = useScrollTrigger({
    disableHysteresis: true,
    threshold: 50,
  });

  return (
    <>
      <HeaderContainer component="header" scrolled={scrolled}>
        <Container maxWidth="xl">
          <Grid container sx={{justifyContent: 'center', alignItems: 'center'}} spacing={2}>
            <LogoContainer item xs={2}>
              <Menu MenuIsOpen={menuIsOpen} SetMenuIsOpen={setMenuIsOpen} />
              <img
                width={150}
                height={32}
                className="logo"
                alt="Weddingly.ai"
                src={Logo}
              />
            </LogoContainer>

            <NavContainer item xs={9}>
              <StickyNavbar
                currentPath={currentPath}
                onTabChange={onTabChange}
              />
            </NavContainer>
          </Grid>
        </Container>
      </HeaderContainer>
      <SideBar MenuIsOpen={menuIsOpen} SetMenuIsOpen={setMenuIsOpen} />
    </>
  );
};

export default Header;
